import axios_instance from './liveChatAxiosInst';

async function getOperators (dispatch) { // console.log('getOperators');
    
    await axios_instance.post(
        process.env.REACT_APP_LIVE_CHAT_API,
        {
            action: 'getOperators',
        },
    )
    .then ((resp) => {
        if (resp.status === 200) { // console.log('Operators : ', resp.data.operatorList)
            dispatch({
                type: 'change_operator_list',
                payload: {operator_list: resp.data.operatorList}});
        } else {
            dispatch({
                type: 'change_operator_list',
                payload: {operator_list: []}});
        }
    })
    .catch (() => 
        dispatch({
            type: 'change_operator_list',
            payload: {operator_list: []}})
    )
}

export default getOperators;